import React, { FC, useEffect, useRef } from 'react';
import { SlideRow } from './SlideRow';
import { SlideColumn, formatSlideCount } from './SlideColumn';

interface OriginalSlidesProps {
  slides: FolderManagerItem[];
  highlightedSlideId?: string | null;
  viewStateKey?: string;
}

export const OriginalSlides: FC<OriginalSlidesProps> = ({ slides, highlightedSlideId, viewStateKey }) => {
  const slideRefs = useRef<Record<string, HTMLDivElement | null>>({});

  useEffect(() => {
    if (!highlightedSlideId) return;
    slideRefs.current[highlightedSlideId]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [highlightedSlideId]);

  return (
    <SlideColumn title="Original Slides" subtitle={formatSlideCount(slides.length)}>
      {slides.map((slide, index) => (
        <SlideRow
          key={slide.id}
          ref={(node) => {
            slideRefs.current[String(slide.id)] = node;
          }}
          slideNumber={index + 1}
          thumbnailUrl={slide.thumbnailUrl}
          viewStateKey={viewStateKey}
          title={slide.displayName || slide.name}
          isHighlighted={highlightedSlideId != null && String(slide.id) === highlightedSlideId}
        />
      ))}
    </SlideColumn>
  );
};
